module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "package"
  }, [_c('div', {
    staticClass: "odiv1"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    class: {
      form: _vm.active
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "组方标识："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "新建组方名不重复"
    },
    model: {
      value: (_vm.inputname),
      callback: function($$v) {
        _vm.inputname = $$v
      },
      expression: "inputname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "50%",
      "border": "1px solid #d6d3d3"
    },
    attrs: {
      "data": _vm.tableData1,
      "border": "",
      "header-cell-style": _vm.tableHeaderColor
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "药名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-input', {
          model: {
            value: (row.number),
            callback: function($$v) {
              _vm.$set(row, "number", $$v)
            },
            expression: "row.number"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "单位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteRow(scope.$index, _vm.tableData1)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-autocomplete', {
    class: {
      autocomplete: _vm.active
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "输入药品名或选择搜索"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  }), _vm._v(" "), _c('el-row', {
    class: {
      button: _vm.active
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addMedicine
    }
  }, [_vm._v("保存组方")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": _vm.backMedicine
    }
  }, [_vm._v("返回")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0081233f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/project/addNew.vue
// module id = 990
// module chunks = 2